import { ReadContractorCard } from "@/types/contractorCard";
import { useContractorCardContext } from "../context";

/**
 * Hook to get safe contractor card data from context
 */
export const useContractorCardData = (): ReadContractorCard => {
  const { data, loadingState, errorState } = useContractorCardContext();

  if (loadingState.isLoading) {
    throw new Error("Contractor card data is still loading");
  }
  if (errorState.error) {
    throw errorState.error;
  }
  if (!data) {
    throw new Error("No contractor card data available");
  }

  return data;
};
